import { createAction, props } from "@ngrx/store";
import { Index } from "../interfaces/State/SeasonPass";

export const setSeasonPasses = createAction('setSeasonPasses', props<{seasonPasses: Array<Index>}>())
export const setOpenedSeasonPass = createAction('setOpenedSeasonPass', props<{seasonPass: Index}>())
